import _extends from "@babel/runtime/helpers/extends";
import { useBanner, bannerHeaderInlineStyleContainer, bannerHeaderInlineStyle, bannerHeaderInlineStyleLogo, commonInlineStyleHeaderHeadline, BannerCloseIcon } from "../../..";
import { forwardRef } from "react"; // eslint-disable-next-line react/display-name

var BannerHeader = /*#__PURE__*/forwardRef(function (_, ref) {
  var banner = useBanner();
  var _banner$headerDesign = banner.headerDesign,
      logo = _banner$headerDesign.logo,
      logoRetina = _banner$headerDesign.logoRetina,
      showCloseIcon = banner.decision.showCloseIcon,
      headline = banner.texts.headline,
      activeAction = banner.activeAction,
      individualPrivacyOpen = banner.individualPrivacyOpen,
      individualTexts = banner.individualTexts,
      headerTitlePrivacyPolicyHistory = banner.i18n.headerTitlePrivacyPolicyHistory; // Calculate logo

  var useRetina = logoRetina && !(logo !== null && logo !== void 0 && logo.endsWith(".svg")) && window.devicePixelRatio > 1;
  var useLogo = useRetina ? logoRetina : logo; // Calculate headline

  var useHeadline = individualPrivacyOpen ? activeAction === "history" ? headerTitlePrivacyPolicyHistory : individualTexts.headline : headline;
  return h("div", _extends({
    ref: ref
  }, bannerHeaderInlineStyleContainer(banner)), h("div", bannerHeaderInlineStyle(banner), !!useLogo && h("img", _extends({
    alt: "",
    src: useLogo
  }, bannerHeaderInlineStyleLogo(banner, useRetina))), !!useHeadline && h("div", commonInlineStyleHeaderHeadline(banner, false), useHeadline), (!!showCloseIcon || !!activeAction) && h(BannerCloseIcon, null)));
});
export { BannerHeader };